/** Rotulos das ocorrencias arboreas (codigos do servidor, occurrence_rules.py). */

export const OCCURRENCE_TYPE_OPTIONS: { code: string; label: string; hint: string }[] = [
  { code: "QUEDA_TOTAL", label: "Queda total", hint: "O exemplar caiu inteiro." },
  { code: "QUEDA_PARCIAL", label: "Queda parcial", hint: "Parte do tronco ou da copa caiu." },
  { code: "QUEDA_GALHO", label: "Queda de galho", hint: "Caiu um ou mais galhos." },
  { code: "TOMBAMENTO", label: "Tombamento / inclinação", hint: "Está inclinando ou com a raiz se soltando." },
  { code: "PRAGA_DOENCA", label: "Praga ou doença", hint: "Cupim, fungo, broca ou outra infestação." },
  { code: "DANO_MECANICO", label: "Dano mecânico", hint: "Batida de veículo, anelamento, corte, vandalismo." },
  { code: "CONFLITO_INFRAESTRUTURA", label: "Conflito com infraestrutura", hint: "Fiação, calçada, muro, edificação." },
  { code: "MORTE_APARENTE", label: "Morte aparente", hint: "Sem folhas e sem sinais de vida." },
  { code: "SUPRESSAO_IRREGULAR", label: "Supressão irregular", hint: "Foi cortado sem autorização." },
  { code: "ARVORE_DESAPARECIDA", label: "Exemplar desaparecido", hint: "Não está mais no local." },
];

export const OCCURRENCE_TYPE_LABELS: Record<string, string> = Object.fromEntries(
  OCCURRENCE_TYPE_OPTIONS.map((o) => [o.code, o.label]),
);

export const OCCURRENCE_STATUS: Record<string, { label: string; badge: string }> = {
  REGISTRADA: { label: "Registrada", badge: "bg-accent-100 text-accent-700" },
  TRIADA: { label: "Triada", badge: "bg-accent-100 text-accent-700" },
  ATRIBUIDA: { label: "Atribuída", badge: "bg-secondary-100 text-secondary-700" },
  EM_VERIFICACAO: { label: "Em verificação", badge: "bg-warning-100 text-warning-800" },
  CONFIRMADA: { label: "Confirmada", badge: "bg-warning-100 text-warning-800" },
  NAO_CONFIRMADA: { label: "Não confirmada", badge: "bg-background-100 text-foreground-600" },
  EM_ATENDIMENTO: { label: "Em atendimento", badge: "bg-warning-100 text-warning-800" },
  ATENDIDA: { label: "Atendida", badge: "bg-primary-100 text-primary-700" },
  ENCERRADA: { label: "Encerrada", badge: "bg-primary-100 text-primary-700" },
  DUPLICADA: { label: "Duplicada", badge: "bg-background-100 text-foreground-600" },
  CANCELADA: { label: "Cancelada", badge: "bg-background-100 text-foreground-600" },
};

/** Status finais (sem transicao seguinte no servidor); os demais contam como abertos. */
export const OCCURRENCE_CLOSED_STATUSES = new Set(["ENCERRADA", "DUPLICADA", "CANCELADA"]);

export const OCCURRENCE_PRIORITY_LABELS: Record<string, string> = {
  P0: "P0 — emergência",
  P1: "P1 — urgente",
  P2: "P2 — alta",
  P3: "P3 — normal",
  P4: "P4 — baixa",
};

export const OCCURRENCE_ACTION_LABELS: Record<string, string> = {
  REGISTRAR: "Registro",
  TRIAR: "Triagem",
  ATRIBUIR: "Atribuição",
  REATRIBUIR: "Troca de responsável",
  CANCELAR: "Cancelamento",
  MARCAR_DUPLICADA: "Marcada como duplicada",
  RECEBER_DUPLICADA: "Recebeu uma duplicada",
};
